import * as React from 'react';
import { MS_PER_DAY } from '@progress/kendo-date-math';
import { MS_PER_MINUTE } from '../constants';
/** @hidden */
export var toSlots = function (_dateRange, _a, _b) {
    var step = _a.step;
    var groups = _b.groups, ranges = _b.ranges;
    var slots = [];
    groups.forEach(function (group) {
        ranges.forEach(function (range) {
            var viewStart = range.zonedStart;
            var viewEnd = range.zonedEnd;
            var offset = (viewEnd.timezoneOffset - viewStart.timezoneOffset);
            for (var current = viewStart.clone(), index = 0, deficiency = offset < 0 ? offset * MS_PER_MINUTE * -1 : 0; current.getTime() < viewEnd.getTime(); index++, current = current.addTime(step)) {
                var _ref = React.createRef();
                var zonedStart = current.clone();
                var zonedEnd = current.addTime(step);
                var difference = (zonedEnd.timezoneOffset - zonedStart.timezoneOffset) * MS_PER_MINUTE;
                var canFill = step < Math.abs(difference);
                if (deficiency && canFill) {
                    deficiency -= step;
                    current = current.addTime(-step);
                }
                var start = new Date(zonedStart.getTime());
                var end = new Date(zonedEnd.getTime());
                var slot = {
                    _ref: _ref,
                    index: index,
                    end: end,
                    start: start,
                    zonedStart: zonedStart,
                    zonedEnd: zonedEnd,
                    range: range,
                    group: group,
                    items: [],
                    isAllDay: MS_PER_DAY <= step
                };
                slots.push(slot);
            }
        });
    });
    return slots;
};
//# sourceMappingURL=slotsService.js.map